import { VimeoData } from '../../../Content';
import { useEffect } from 'react';

interface VimeoContentProps {
  content: VimeoData;
}

export const VimeoContent: React.FC<VimeoContentProps> = ({ content }) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
      <iframe
        title="vimeo-player"
        src={
          'https://player.vimeo.com/video/' +
          content.vimeoID +
          '?autoplay=1&title=0&byline=0&portrait=0'
        }
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};
